(function () {
  'use strict';

  var formId = '927384';
  var suppressionDays = 7;
  var suppressionDuration = suppressionDays * 24 * 60 * 60 * 1000;
  var suppressionKey = 'domov-stromov:shopify-forms:' + formId + ':hidden-until';
  var dismissalKey = formId + '-dismissed-in-session';
  var formsSessionKey = 'forms_session_id';
  var legacyFallbackSessionKey = 'forms_fallback_session_id';
  var suppressionAttribute = 'data-newsletter-popup-suppressed';
  var formContainerId = 'app-embed-container-' + formId;
  var expiryTimer;

  function getStoredValue(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStoredValue(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function removeStoredValue(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // The popup keeps Shopify's native behavior when storage is unavailable.
    }
  }

  function getCookie(name) {
    var cookiePrefix = name + '=';
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var index = 0; index < cookies.length; index += 1) {
      if (cookies[index].indexOf(cookiePrefix) === 0) {
        return cookies[index].slice(cookiePrefix.length);
      }
    }

    return null;
  }

  function getCurrentFormsSession() {
    return (
      getStoredValue(formsSessionKey) ||
      getStoredValue(legacyFallbackSessionKey) ||
      getCookie('_shopify_s')
    );
  }

  function scheduleExpiry(hiddenUntil) {
    window.clearTimeout(expiryTimer);
    expiryTimer = window.setTimeout(function () {
      applySuppression();
    }, Math.max(0, hiddenUntil - Date.now()) + 100);
  }

  function applySuppression() {
    var hiddenUntil = Number.parseInt(getStoredValue(suppressionKey), 10);
    var isSuppressed = Number.isFinite(hiddenUntil) && hiddenUntil > Date.now();

    if (isSuppressed) {
      document.documentElement.setAttribute(suppressionAttribute, 'true');
      scheduleExpiry(hiddenUntil);
      return;
    }

    document.documentElement.removeAttribute(suppressionAttribute);
    removeStoredValue(suppressionKey);
    window.clearTimeout(expiryTimer);
  }

  function rememberDismissal() {
    var dismissedSession = getStoredValue(dismissalKey);
    var currentSession = getCurrentFormsSession();

    if (!dismissedSession || !currentSession || dismissedSession !== currentSession) {
      return;
    }

    var hiddenUntil = Date.now() + suppressionDuration;

    if (setStoredValue(suppressionKey, String(hiddenUntil))) {
      applySuppression();
    }
  }

  function eventComesFromNewsletter(event) {
    var eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];

    return eventPath.some(function (element) {
      return element && element.id === formContainerId;
    });
  }

  function checkInteraction(event) {
    if (!eventComesFromNewsletter(event)) {
      return;
    }

    window.setTimeout(rememberDismissal, 0);
  }

  applySuppression();
  document.addEventListener('click', checkInteraction, true);
  document.addEventListener('keydown', checkInteraction, true);
  window.addEventListener('pageshow', applySuppression);
  window.addEventListener('storage', function (event) {
    if (event.key === suppressionKey) {
      applySuppression();
    }
  });
})();
